import { ILookBookItem } from '../components/types'
import { lookbook_items_elements_nodes } from '../__generated__/lookbook_items'
import { getImageSrc } from './utils'

export const createLookBookItem = (
  node: lookbook_items_elements_nodes,
): ILookBookItem => {
  return {
    name: node.name,
    img: getImageSrc(node.detailPicture?.url),
    link: `/lookbook/${node.code}`,
    id: node.id,
  }
}
